<div class="card new-card">
    <app-card-title title="Cabine" icon="aar-icon-cabin"></app-card-title>
    <div class="cabin-container">
        <div class="icon-text">
          <i class="icon-green" [ngClass]="cabin"></i>
          <div class="text-info">
            <h4>{{ typeLabel }}</h4>
            <p>{{ subtypeLabel }}</p>
          </div>
        </div>
      </div>
</div>